<template>
  <div class="photoMore" v-infinite-scroll="getPhotos" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
  	<CustomizeHeader :home="false" :goBack="true"  title="寫真"></CustomizeHeader>
    <v-row class="py-1 ma-0">
      <v-col
        style="padding: 6px"
        cols="4" 
        sm="3" 
        md="2" 
        lg="1" 
        xl="1" 
        v-for="item in items"
        :key="item.id"
      >
        <v-card class="story-item"
          flat
          @click="$root.$emit('story', Object.assign(item, {id: item.seller_id}), item, item.product_type)"
        >
          <span class="free" v-if="item.price === 0">Free</span>
          <span class="unlocked" v-else-if="purchaseID.includes(item.id)">已解鎖</span>
          <v-img
            :src="$func.productImagePreview(item)"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.4)"
            height="100%"
            aspect-ratio="0.75"
          >
            <v-avatar size="35" @click.stop="$router.push(`/seller/${item.seller_id}`)">
              <v-img :src="$HOST_URL + item.usericon"/>
            </v-avatar>
            <div class="description" :title="item.title">{{ item.title }}</div>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CustomizeHeader from '@/components/CustomizeHeader'
export default {
  components: { CustomizeHeader },
  data() {
    return {
      busy: false,
      page: 1,
      items: []
    }
  },
  computed: {
    ...mapGetters('user', ['purchaseID'])
},
  methods: {
    getPhotos() {
      this.busy = true
      this.axios.post('/products/condition', {
        search : [
          {table: 'products', column: 'product_type', keyword: 'photo'}
        ],
        page: this.page,
        size: 50,
        includeSeller: true,
        sort: {
          table: 'products',
          column: 'created_at',
          by: 'desc'
        },
      }).then(response => {
        this.items = this.items.concat(response.data.data)
        if(this.page != response.data.last_page) {
          this.page += 1  
          this.busy = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.photoMore {
  .product-item {
    display: block;
  }
}
</style>